// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"64":"c1193f3a","301":"bc916795","722":"b9b23fc2","902":"30c6ee64"}[chunkId] + ".chunk.js";
};